import lrImg from './_src/lrImg.vue'
lrImg.install = function(Vue) {
  Vue.component(lrImg.name, lrImg)
}
export default lrImg